<template>
  <div class="control" :class="['control', {'is-loading': isLoading}]">
    <div :class="['dropdown hp-dropdown hp-dropdown--input', { 'is-active' : isOpen && results.length > 0}]">
      <div class="dropdown-menu" role="menu">
        <div class="dropdown-content is-paddingless">
          <a v-for="(result, i) in results" :key="i" @click.prevent="setResult(result)" href="#" :ref="`${result.id}`" :class="['dropdown-item', 'has-text-left']"
             v-html="result.name"></a>
        </div>
      </div>
    </div>
    <input
        autocomplete="off"
        type="text"
        :tabindex="tabIndex"
        v-model="search"
        @input="onChange"
        @blur="onBlur"
        @keydown.enter="onEnter"
        class="input hp-input"
        :name="inputFieldName"
        :placeholder="placeHolder"/>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'ReviewBusinessSearch',
  props: {
    tabIndex: {
      type: Number,
      required: false,
      default: 1
    },
    inputFieldName: {
      type: String,
      required: false,
      default: 'business'
    },
    placeHolder: {
      type: String,
      required: false,
      default: 'Search for or add a new business'
    }
  },
  data() {
    return {
      isOpen: false,
      isBlur: false,
      results: [],
      items: [],
      search: '',
      isLoading: false,
      isLoaded: false,
      ignoreChange: false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  watch: {
    items(val, oldValue) {
      this.results = val
      this.isLoading = false
    },
    search(val, oldValue) {
      if (this.results && this.results[0] && this.results[0].name === val) {
        window.events.$emit('business-search', this.results[0])
      } else if ((!this.results && val) || (this.results && this.results[0] && this.results[0].name !== val)) {
        window.events.$emit('clear-business-search')
      }
      if (typeof val !== 'undefined' && !this.ignoreChange) {
        if (val.length !== oldValue.length && val.length > 2) {
          this.isLoading = true
          const keyword = encodeURIComponent(val)
          axios.get(`/search/business?name=${keyword}`)
              .then(({data}) => {
                if (val === this.search) {
                  this.isLoading = false
                  this.items = data
                  this.isOpen = true
                }
              })
              .catch((error) => {
                console.log(`error searching for business from keyword string [${val}]`, error.response)
                this.items = []
                this.isLoading = false
                this.isOpen = false
              })
        }
      } else if (val.length === 0) {
        this.items = []
        this.isLoading = false
        this.isOpen = false
      } else {
        this.items = []
        this.isLoading = false
        this.isOpen = false
      }
      this.ignoreChange = false
    },
    results() {
      if (this.results.length > 0 && !this.isLoaded) {
        this.setSearch()
      }
    },
    isBlur() {
      if (this.results.length > 0) {
        this.setSearch()
      }
    }
  },
  methods: {
    onBlur() {
      this.ignoreChange = false
      this.isBlur = true
    },
    setSearch() {
      if (this.isBlur) {
        for (var i = 0; i < this.results.length; i++) {
          if (this.results[i].name.trim().toLowerCase() === this.search.trim().toLowerCase()) {
            this.triggerAutoSelect(this.results[i]);
          } else {
            if (this.results[i].aliases !== null && this.results[i].aliases.length > 0) {
              this.results[i].aliases.forEach((item, index) => {
                if (item.alias.trim().toLowerCase() === this.search.trim().toLowerCase()) {
                  this.triggerAutoSelect(this.results[i])
                }
              })
            }
          }
        }
      }
    },
    triggerAutoSelect(searchedResult) {
      this.$emit('businessSelected', searchedResult)
      this.isLoaded = true
      this.isOpen = true
    },
    onChange() {
      this.$emit("input", this.search)
      this.isOpen = false
      this.isLoaded = false
      this.isBlur = false
    },
    setResult(result) {
      this.ignoreChange = true
      this.$emit('businessSelected', result)
      this.search = result.name.trim()
      this.isOpen = false
      this.isLoading = false
    },
    onEnter() {
      this.ignoreChange = true
      if (this.results.length > 0) {
        this.$emit('businessSelected', this.results[0])
        this.search = this.results[0].name.trim()
      } else {
        this.$emit('businessSelected', {
          id: null,
          name: this.search.trim(),
          slug: null,
          status: null,
          primary_email: null,
          subscription: null,
          accepted_invites_count: 0
        })
      }
      this.isOpen = false
      this.isLoading = false
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReviewBusinessSearch.vue